import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function AdventurersClubFound() {
  const dateTexts = ['1911年'];
  const title = 'アドベンチャラーズクラブ設立';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2020/09/AdventurersClubExterior.jpg'
  const description = (
    <>
      {'船乗りの冒険家でありS.E.A.会員の'}
      <a href='/merriweather-adam-pleasure'>
        {'メリウェザー・アダム・プレジャー'}
      </a>
      {'が、航海の途中である無人島を発見・開拓し、「プレジャーアイランド」と名づける。そして冒険家たちが集うクラブ「'}
      <a href='/adventurers-club'>
        {'アドベンチャラーズクラブ'}
      </a>
      {'」を造り上げる。'}
    </>
  );
  const quoteDomain = 'en.wikipedia.org';

  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      imgUrl={imgUrl}
      quoteDomain={quoteDomain}
    />
  );
}

export default AdventurersClubFound;
